import { Form } from 'antd';
import useChooseStore from 'modules/auth/hooks/useChooseStore';
import authActions from 'modules/auth/services/actions';
import authApis from 'modules/auth/services/apis';
import { IOwnerLoginResData } from 'modules/auth/services/types/owner';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IResponseDataBody } from 'services/response';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import FormLogin from './FormLogin';
import OverlayBG from './OverlayBG';
import Policy from './Policy';
type ILoginPageProps = any;
const LoginPage: React.FC<ILoginPageProps> = () => {
  const [form] = Form.useForm();
  const chooseStore = useChooseStore();
  const setPageLoading = useSetLoadingPage();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleFinish = async (values: any) => {
    setPageLoading(true);
    try {
      const body = { email: values.username, password: values.password };
      const res: IResponseDataBody<IOwnerLoginResData> = await authApis.ownerLogin(body);
      if (res.data.data) {
        dispatch(authActions.ownerLogin.success(res.data.data));
        if (res.data.data.shops.length === 1) {
          chooseStore(res.data.data.shops[0]);
          return;
        }
        navigate('/owner/dashboard');
      }
    } catch (error) {
    } finally {
      setPageLoading(false);
    }

  };

  return (
    <Wrapper>
      <OverlayBG />
      <Container>
        <FormLogin form={form} onFinish={handleFinish} initialValues={{ username: 'demo@fozito.com', password: '987654321' }} />
        <Policy />
      </Container>
    </Wrapper>
  );
};

export default LoginPage;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
`;
